import CatalogBack from 'app/assets/images/about-catalog-back.svg';
import Catalog from 'app/assets/images/about-catalog.png';

export default {
  background: CatalogBack,
  image: Catalog,
  title: 'Explore Our Catalog',
  link: '#',
  linkText: 'Download'
}